import css from './main-layout.scss';

const MainLayout = (props) => {
    return (
        <div className={css.root}>
            {props.children}
        </div>
    )
}

export default MainLayout